{
  "messages": {
    "networkError": "发生网络错误。如果问题仍然存在，请联系我们。",
    "appointmentUpdatedValidationFailed": "预约已更新，但未通过外部验证。",
    "appointmentCreatedValidationFailed": "预约已创建，但未通过外部验证。",
    "validationErrorDetail": "<br /> 验证错误：{error}"
  },
  "titles": {
    "warehouseRuleFailed": "未通过仓库规则",
    "validationServerError": "验证服务器错误",
    "appointmentUpdatedWithValidationError": "预约已更新，但存在验证错误",
    "appointmentCreatedWithValidationError": "预约已创建，但存在验证错误"
  }
}
